export default __webpack_public_path__ + "static/media/ice_icon128.0d25e6b7.png";